export const labs: { [key: string]: string } = {
  foundation_one: 'Foundation',
  tempus: 'Tempus',
  foundation_liquid: 'Foundation Liquid',
  guardant: 'Guardant'
}
